// extracted by mini-css-extract-plugin
export default {"card":"ProfileView_card__CljVW","name":"ProfileView_name__a0hct"};